const fundialMethods = {
  fundialGetCategory: {
    online: true,
    requiredLogin: false,
    enableRecaptcha: true,
    apiSuffixName: 'v1/catalog',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['categoryId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialSearch: {
    online: true,
    requiredLogin: false,
    enableRecaptcha: true,
    apiSuffixName: 'v1/search',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['query'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialGetSubscribers: {
    online: true,
    requiredLogin: true,
    enableRecaptcha: true,
    apiSuffixName: 'v1/subscribers',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  fundialGetGallery: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'v1/subscribers/gallery',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialGetAoc: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'v1/purchase/aoc',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriber', 'productId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialAddContact: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'v1/profile/addSongContacts',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Subscriber', 'SongId', 'PhoneNumbers'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialDeleteSong: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'v1/profile/deleteSong',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Subscriber', 'SongId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialSetDefaultSong: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'v1/profile/setDefaultSong',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Subscriber', 'SongId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialSetShuffle: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'v1/profile/setShuffle',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Subscriber', 'ProfileId', 'IsSetShuffle'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialDeleteContact: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'v1/profile/deleteSongContact',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Subscriber', 'ProfileId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialRemoveFromPlaylist: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'v1/playlist/removeSong',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Subscriber', 'SongId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialPurchase: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'v1/purchase',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: ['Subscriber', 'OrderString', 'IsDefault', 'IsPremium'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  fundialPurchasePricePlan: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'v1/purchase/priceplan',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: ['Subscriber', 'NewSocCode'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
};

export default fundialMethods;
